export default __webpack_public_path__ + "static/media/07_photo.7c302ed3.jpg";